import React from 'react';
import style from './style.css';

const Spinner = () => {

  return (
    <div className={ style.spinner }/>
  );
};

export default Spinner;



// WEBPACK FOOTER //
// ./client/src/components/spinner/index.js